import React from 'react'
import { styled } from '@mui/material/styles'
import Card, { CardProps } from '@mui/material/Card'
import Button, { ButtonProps } from '@mui/material/Button'
import Box, { BoxProps } from '@mui/material/Box'
import {
  borderColor,
  panelRadius,
  shadow1,
  surfaceRadius,
} from 'src/ui/theme/tokens'
import { buttonAppearance, buttonBase } from 'src/ui/theme/buttonStyles'

// Compatibility names: consumers now share A4 Soft surfaces, not blurred glass.
export const GlassCard = styled(Card)<CardProps>(() => ({
  borderRadius: surfaceRadius,
  border: `1px solid ${borderColor}`,
  background: '#ffffff',
  boxShadow: shadow1,
  backdropFilter: 'none',
  overflow: 'hidden',
}))
export const GlassPanel = styled(Box)<BoxProps>(() => ({
  borderRadius: panelRadius,
  border: `1px solid ${borderColor}`,
  background: '#f7fbfe',
  boxShadow: '0 2px 0 #e0eaf2',
  backdropFilter: 'none',
}))
const SoftActionButton = styled(Button)<ButtonProps>(({ variant, color }) => ({
  ...buttonBase,
  ...buttonAppearance(variant, color),
}))
export const GlassButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function GlassButton(
    { variant = 'contained', className = '', ...props },
    ref,
  ) {
    return (
      <SoftActionButton
        {...props}
        ref={ref}
        variant={variant}
        className={`rt-primary-action ${className}`}
      />
    )
  },
)
export const GlassOutlineButton = React.forwardRef<
  HTMLButtonElement,
  ButtonProps
>(function GlassOutlineButton(
  { variant = 'outlined', className = '', ...props },
  ref,
) {
  return (
    <SoftActionButton
      {...props}
      ref={ref}
      variant={variant}
      className={`rt-outline-action ${className}`}
    />
  )
})
